import React from 'react'
import SubHeader from '../../../layout/components/SubHeader'
import {toAbsoluteUrl} from '../../../helpers/AssetHelpers'
import FeatureCard from './FeatureCard'

function Features() {
    return (
        <>
            <SubHeader title="Eyeconx Features" description={"Services and features provided by Eyeconx."}/>
            <div className="row mt-3">
                <div className="col-3">
                    <img src={toAbsoluteUrl('/media/illustrations/ecx/features-overview_uone.svg')} className='img-fluid p-5' />
                </div>
                <div className="col-9">
                    <FeatureCard />
                </div>
            </div>
        </>
    )
}

export default Features